import React from 'react';

import StatusBox from 'components/StatusBox';
import {KYC_STATUSES_COLORS} from 'ducks/bookings';

interface KycStatusBoxProps {
  kycBooleanStatus: boolean;
}

class KycStatusBox extends React.Component<KycStatusBoxProps> {
  render() {
    const {kycBooleanStatus} = this.props;

    // This currently only reseives `true` or `null` statuses as we're not clear on when
    // the kyc is expired.
    const kycStatus = kycBooleanStatus ? 'verified' : 'pending';

    return (
      <StatusBox color={KYC_STATUSES_COLORS[kycStatus]} status={kycStatus} />
    );
  }
}

export default KycStatusBox;
